import { BasicAuthServiceHelper } from '@/modules/Auth'
import { AppDispatch } from '@/store'
import * as GetPetsitter from './apiTypes/GetPetsitter'
import { PetsitterUserTypes } from './PetsitterUserReducer'

export const dispatchGetPetsitterInfoAsync =
  (dispatch?: AppDispatch) =>
  /**
   * Will refresh the current petsitter and set it in Reducer
   * @returns The new Petsitter
   */
  async (paramsToDispatch?: { reactivation?: boolean }) => {
    const petsitter = await BasicAuthServiceHelper.requestAuthenticatedV2Async<GetPetsitter.Response>(
      GetPetsitter.Route,
    )

    if (dispatch) {
      dispatch({ type: PetsitterUserTypes.UpdatePetsitter, payload: { ...petsitter, ...paramsToDispatch } })
    }

    return petsitter
  }
